import { isAuthTokenExpired } from '../../../context/DynamicContext/helpers.js';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../shared/logger.js';
import { getDynamicLSKey } from '../../../shared/utils/functions/storage/getDynamicLSKey.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/utils';
import { AUTH_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import 'ethers';
import '../../../shared/consts/index.js';

const getAuthToken = () => {
    var _a, _b;
    if (typeof window === 'undefined') {
        return undefined;
    }
    let token = (_a = window.localStorage.getItem(getDynamicLSKey(AUTH_TOKEN))) !== null && _a !== void 0 ? _a : undefined;
    if (!token) {
        return undefined;
    }
    try {
        const parsedToken = (_b = JSON.parse(token)) !== null && _b !== void 0 ? _b : undefined;
        if (parsedToken) {
            token = parsedToken;
        }
    }
    catch (err) {
        logger.error(err);
        return token;
    }
    if (isAuthTokenExpired(token)) {
        return undefined;
    }
    return token;
};

export { getAuthToken };
